const SelectFilterStyles = theme => ({
  mainContainer: {
    zIndex: ({ open }) => (open ? 10000 : 0)
  },
  list: {
    outline: '0 !important'
  },
  listHeader: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.30)'
  },
  listHeaderItem: {
    height: 32,
    backgroundColor: 'white',
    paddingLeft: 0,
    paddingRight: 0
  },
  searchItem: {
    height: 32,
    backgroundColor: 'white',
    border: '1px solid rgba(0, 0, 0, 0.30)',
    margin: 4,
    borderRadius: 5,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 5,
    paddingRight: 5
  },
  searchInput: {
    flex: 1,
    border: 'none',
    outline: '0 !important',
    fontSize: '14px',
    fontFamily: theme.typography.fontFamily,
    lineHeight: 'inherit',
    width: '50%'
  },
  searchIcon: {
    color: 'rgba(0, 0, 0, 0.30)'
  },
  switch: {
    top: -7,
    left: -7,
    '&:hover': {
      backgroundColor: 'transparent'
    },
    '& .MuiSwitch-thumb': {
      backgroundColor: '#e6e6e6'
    },
    '&.Mui-checked .MuiSwitch-thumb': {
      backgroundColor: 'currentColor'
    }
  },
  checkboxAllItemsIcon: {
    paddingLeft: 16,
    paddingRight: 13
  },
  lisItemContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%'
  },
  listItemTextContainer: {
    marginRight: '11px'
  },
  listItemText: {
    fontSize: '14px',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  fieldContainer: {
    border: '1px solid #E0E0E0',
    height: '29px',
    lineHeight: '29px',
    borderRadius: '2px',
    backgroundColor: 'white',
    marginTop: '16px',
    cursor: 'pointer',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    '&:hover': {
      borderBottom: '1.2px solid rgba(0, 0, 0, 0.7)'
    },
    '& svg': {
      color: 'rgba(0, 0, 0, 0.54)'
    }
  },
  fieldContainerError: {
    borderBottom: '1.2px solid #f44336 !important'
  },
  field: {
    height: '100%',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    lineHeight: 'inherit',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    paddingLeft: '5px',
    fontSize: '14px',
    fontFamily: theme.typography.fontFamily
  },
  customPopover: {
    display: 'none',
    position: 'absolute',
    top: ({ inputContainerEl }) => {
      return inputContainerEl
        ? inputContainerEl.offsetHeight + inputContainerEl.offsetTop
        : 0;
    },
    backgroundColor: 'white',
    zIndex: 2,
    boxShadow:
      '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
    border: '1px solid #E0E0E0',
    outline: '0 !important'
  },
  customPopoverOpen: {
    display: 'initial'
  },
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    zIndex: 0
  }
});

export default SelectFilterStyles;
